module.exports = __webpack_public_path__ + "img/img65.df90126c.png";